import { render, staticRenderFns } from "./ResubmitWithdrawalSummary.vue?vue&type=template&id=3bd36197&scoped=true"
import script from "./ResubmitWithdrawalSummary.vue?vue&type=script&lang=js"
export * from "./ResubmitWithdrawalSummary.vue?vue&type=script&lang=js"
import style0 from "./ResubmitWithdrawalSummary.vue?vue&type=style&index=0&id=3bd36197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd36197",
  null
  
)

export default component.exports